// extracted by mini-css-extract-plugin
export default {"label":"CopyCommentEmbedCodeContainer-label-a832c2d670f1450b0e092e4929766f11","embedCodeCopied":"CopyCommentEmbedCodeContainer-embedCodeCopied-e68f7140f18713e19914238dddd57f31"};